import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
    GET_TASK_TEMPLATE_PENDING,
    GET_TASK_TEMPLATE,
    SG_GET_TASK_TEMPLATE,
    DELETE_TASK_TEMPLATE,
    SG_DELETE_TASK_TEMPLATE,
    FETCH_TASK_TEMPLATE,
    SG_FETCH_TASK_TEMPLATE,
    EDIT_TASK_TEMPLATE,
    SG_EDIT_TASK_TEMPLATE,
    ADD_TASK_TEMPLATE,
    SG_ADD_TASK_TEMPLATE,
    ALL_ERRORS,
  } from "constants/actions";
  import { handleError } from "./ApiError";

function* loadmethods(action) {
    yield put({ type: GET_TASK_TEMPLATE_PENDING });

  try {
    const json = yield call(api.GET_TASK_TEMPLATE, action.payload);
    yield put({ type: GET_TASK_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_TASK_TEMPLATE, loadmethods);
}

function* fetchmethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_PENDING });
  try {
    const json = yield call(api.FETCH_TASK_TEMPLATE, action.payload);
    yield put({ type: FETCH_TASK_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_TASK_TEMPLATE, fetchmethods);
}

function* updatemethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_PENDING });
  try {
    const json = yield call(api.EDIT_TASK_TEMPLATE, action.payload);
    yield put({ type: EDIT_TASK_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_TASK_TEMPLATE, updatemethods);
}


function* addmethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_PENDING });
  try {
    const json = yield call(api.ADD_TASK_TEMPLATE, action.payload);
    yield put({ type: ADD_TASK_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_TASK_TEMPLATE, addmethods);
}

function* deletemethods(action) {
  yield put({ type: GET_TASK_TEMPLATE_PENDING });
  try {
    yield call(api.DELETE_TASK_TEMPLATE, action.payload);
    yield put({ type: DELETE_TASK_TEMPLATE, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_TASK_TEMPLATE, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
